/**
 * E-mail domains of the company staff: Agres, and Tecomec Brasil since the
 * rebrand.
 */
export const INTERNAL_EMAIL_DOMAINS: readonly string[] = [
  'agres.com.br',
  'tecomec.com.br',
];

const EMAIL_DOMAIN_SEPARATOR = '@';

/**
 * Whether an account belongs to the company staff.
 *
 * @param email - The user's e-mail, which is also the user id.
 * @returns `true` when the domain after the last `@` is one of
 * `INTERNAL_EMAIL_DOMAINS`, ignoring case and surrounding spaces.
 *
 * @remarks
 * The whole domain must match: `x@agres.com.br.example.com` and
 * `x@sub.agres.com.br` are customers.
 */
export function isInternalUser(email: string | null | undefined): boolean {
  if (typeof email !== 'string') {
    return false;
  }
  const separatorIndex = email.lastIndexOf(EMAIL_DOMAIN_SEPARATOR);
  if (separatorIndex < 0) {
    return false;
  }
  const domain = email
    .slice(separatorIndex + 1)
    .trim()
    .toLowerCase();
  return INTERNAL_EMAIL_DOMAINS.includes(domain);
}
